export function slideToggle(element, timing = 500, attribute = 'height', display = 'block') {
    element.style.transition = `${attribute} ${timing}ms ease`;
    element.style.overflow = 'hidden';

    if (element.style.display !== display) {
        element.style.display = 'block';
        element.style[attribute] = 'auto';

        let value = (attribute === 'width' ? element.clientWidth : element.clientHeight) + 'px';
        element.style[attribute] = '0px';
        setTimeout(() => element.style[attribute] = value, 0);
    } else {
        element.style[attribute] = '0px';
        element.addEventListener('transitionend',
            () => element.style.display = 'none',
            { once: true },
        );
    }
}
